import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import GlideSlider from '../base';

// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'slider',
  rewind: false,
  perTouch: 1,
  perView: 1,
  dragThreshold: false,
  focusAt: 'center',
  breakpoints: {
    [breakpoints['break-1']]: {
      focusAt: 'center',
    },
    [breakpoints['break-2'] - 1]: {
      focusAt: 'center',
    },
    [breakpoints['break-2']]: {
      focusAt: 0,
      perView: 1,
    },
  },
};

const fullWidthGlideOptions = {
  type: 'slider',
  rewind: false,
  perTouch: 1,
  perView: 1,
  dragThreshold: false,
  focusAt: 'center',
};

const selectors = {
  slideSelector: '[data-image-slider-with-captions-slide]',
  leftArrowSelector: '[data-image-slider-with-captions-arrow-left]',
  rightArrowSelector: '[data-image-slider-with-captions-arrow-right]',
  slideIndicatorSelector: '[data-image-slider-with-captions-indicator]',
  slideIndicatorActiveClass:
    'section-image-slider-with-captions__nav-btn--active',
};

export default class SectionImageSliderWithCaptions extends Component {
  static selector = '[data-comp-image-slider-with-captions]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.isFullWidth = this.$container.hasAttribute(
      'data-image-slider-full-width',
    );

    this.slider = new GlideSlider(
      containerEl,
      this.isFullWidth ? fullWidthGlideOptions : glideOptions,
      selectors,
    );
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run these events after mounting the slide
    // And after transitioning between two slides
    this.sliderGlideInstance.on(['mount.after', 'run.after'], () => {
      const slideWidth = this.slider.getSliderWidth();

      this.slider.adjustSlideWidth(slideWidth);
      this.slider.handleArrowButtonState();
    });

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    this.sliderGlideInstance.mount();
  }
}
